import { forwardRef } from 'react';

export const NrofBrokersPerRegion = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        viewBox="0 0 113.4 113.4"
        ref={ref}
        xmlSpace="preserve"
        {...props}
      >
        <style>
          {
            '.st2{fill:none;stroke:#004b54;stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st7{fill:#004b54}'
          }
        </style>
        <circle className="st2" cx={58.8} cy={51.4} r={8.9} />
        <path
          className="st2"
          d="M48.3 64.8c-6 0-7.5 7.2-7.5 7.2-1.4 6.4-2.6 12.9-2.6 14.3 0 4.2 3.9 3.6 8.8 3.6M69.3 64.8c6 0 7.5 7.2 7.5 7.2 1.4 6.4 2.6 12.9 2.6 14.3 0 4.2-4.6 3.6-8.8 3.6M63.4 94.2 61 68.3c-.1-.5-.4-.8-.8-.8h-2.8c-.4 0-.8.4-.8.8l-2.3 25.9c0 .3.1.7.3.9l3.8 3.5c.2.1.3.2.5.2s.4-.1.5-.2l3.8-3.5c.1-.2.2-.5.2-.9z"
        />
        <circle className="st2" cx={88.9} cy={42.2} r={8.9} />
        <path
          className="st2"
          d="M78.3 55.6c-3.4 0-5.3 2.3-6.4 4.3M99.4 55.6c6 0 7.5 7.2 7.5 7.2 1.4 6.4 2.6 12.9 2.6 14.3 0 4.2-4.6 3.6-8.8 3.6M93.5 85l-2.3-25.9c-.1-.5-.4-.8-.8-.8h-2.8c-.4 0-.8.4-.8.8L84.3 85c0 .3.1.7.3.9l3.8 3.5c.2.1.3.2.5.2s.4-.1.5-.2l3.8-3.5c.2-.2.3-.5.3-.9zM54.1 34.6c-2.2-2.7-.2-4.9-.6-6.2-.5-1.4-3.8-2.7-4.4-4.2-.6-1.5-.2-3-1.3-3.8-1.2-.8-3.7.4-3.7.4-1.4 1.1-2.9 3.3-4.4 4.3-1 .6-4-.2-4-.2 1.7-3.6 1.7-3.9-1.5-4.3-1.2-.1-3.3-.4-3.3-1-.2-2.6-2-4.7-4-5-5.5-.8-4.8 1.2-3.4 5.6-3.7 1.5-.3 3.9-.4 5.5-1.3 1-4 2.7-4 2.5-1.9.1-4.1-1.5-5.7-.8-1 .5-2.3 4-2.7 5.5-.2.6 1.3 1.3 1.3 1.9.1 1.2.3 2.4-1.5 3-.3.1-.5 1.3-.4 1.8.3.8.9 1.4 1.8 2.6v.2c-2.1.8-4.5 1.4-6.2 2.2-.5.2-1.8.3-1.7 1.3.3 1.1 1.1 5.1.1 7.5-.3.7-.3 1.7 0 2.5.4 1.2 1.1 2.5 1 3.7-.1 2.1-2.4 4.4.3 6.2.1 0 0 .3 0 .5-.1 3.9-.8 3.7 6.3 5.1 1.5.3 3.3.1 4.7 1.5 1.4 1.4-3.6 7.9-3.8 12 0 .5.6 1.4.9 1.4 2.4 0 5 1.2 7.1-1.7 2.6 1 4 1.9 6.5 3 1.3.5 2.2.7 3.3-.6"
        />
        <circle className="st7" cx={19.9} cy={54.9} r={2.4} />
        <circle className="st7" cx={30.9} cy={38.5} r={2.4} />
        <circle className="st7" cx={31} cy={72.1} r={2.4} />
      </svg>
    );
  },
);
